import MuiButton, { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import MuiCircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

export interface SubmitButtonProps extends MuiButtonProps {
  loading?: boolean;
  dataFd: string;
}

const Button = withStyles<'root', {}, MuiButtonProps>(
  (theme) => ({
    root: {
      // disable shadow and nice things
      boxShadow: 'none',
      borderRadius: 0,

      '&.MuiButton-contained': {
        '& .MuiTypography-button': {
          marginLeft: theme.spacing(1)
        }
      },
      [theme.breakpoints.down('xs')]: {
        cursor: 'pointer',
        borderRadius: 0,
        padding: theme.spacing(2),
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        verticalAlign: 'baseline',
        zIndex: theme.zIndex.appBar,
        '& span': {
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          textAlign: 'center'
        }
      }
    }
  }),
  { name: 'FdSubmitButton' }
)(MuiButton);

const CircularProgress = withStyles<'root', {}, CircularProgressProps>(
  (theme) => ({
    root: {
      [theme.breakpoints.down('xs')]: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
      }
    }
  }),
  { name: 'FdSubmitCircularProgress' }
)(MuiCircularProgress);

const SubmitButton: React.FC<SubmitButtonProps> = ({
  loading,
  disabled,
  children,
  size,
  dataFd,
  ...rest
}) => {
  return (
    <Button {...rest} size={size} disabled={disabled || loading} data-fd={dataFd}>
      {loading ? (
        <CircularProgress size={size === 'large' ? 20 : 16} color="inherit" aria-hidden />
      ) : null}

      <Typography variant="button" component="span">
        {children}
      </Typography>
    </Button>
  );
};

SubmitButton.defaultProps = {
  type: 'submit',
  variant: 'contained',
  color: 'primary',
  size: 'large',
  fullWidth: true
};

export default SubmitButton;
